import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useThemeMode } from '../../ThemeContext';

function FAQ() {
  const { mode } = useThemeMode();
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  // FAQ data
  const faqData = [
    {
      question: "What is the WHS Assistant and how does it work?",
      answer: "The WHS Assistant is your built-in AI compliance officer. It instantly answers questions by pulling information from your uploaded documents (policies, procedures, registers) and mapping them to WHS legislation, ISO standards, and Government requirements. Whether it's \"What's our fatigue management procedure?\" or \"Which clause covers emergency planning?\", you'll have the answer in seconds — 24/7."
    },
    {
      question: "Is my data and document storage secure?",
      answer: "Yes. Complimate is fully hosted in Australia, encrypted at rest and in transit, and backed by strict role-based access controls. Only authorised users can access your documents, with every action logged for traceability."
    },
    {
      question: "Can I manage different users and control their access?",
      answer: "Absolutely. You can create user roles, assign job descriptions, and link responsibilities directly to compliance tasks. Access can be restricted by role (e.g. Manager, Supervisor, Worker) so each person only sees and manages what they're responsible for."
    },
    {
      question: "Will I get alerts when documents or tasks expire?",
      answer: "Yes. Complimate automatically tracks expiry dates on documents, training, and licences. You'll receive alerts before deadlines and see overdue items flagged in the dashboard. Corrective actions and tasks can also be assigned, tracked, and closed out to keep your compliance current."
    },
    {
      question: "What happens if I exceed the limits in the Starter Plan?",
      answer: "If you go beyond the document or query limits in the Starter Plan, you'll still keep access to your account and data. You'll be prompted to upgrade to a plan that fits your workload, with simple, transparent pricing and no loss of information."
    },
    {
      question: "Do I need a credit card to start the free trial?",
      answer: "No. You can try Complimate for free without entering card details. Upload documents, ask the WHS Assistant, and test the features before deciding on a plan."
    },
    {
      question: "How is Complimate different from other compliance tools?",
      answer: "Complimate was built by consultants and frontline workers who live compliance every day. Unlike generic document platforms, it gives you clause-cited audits, instant policies and procedures, corrective action tracking, and regulator-ready reports — everything in one platform, built for Australian industries."
    }
  ];

  return (
    <>
      {/* FAQ Section */}
      <section className="faq-section" id="faq">
        <Container>
          <div className="faq-header">
            <h2 className="faq-title">Frequently Asked Questions</h2>
            <div className="faq-subtitle">Still have questions? We've got answers.</div>
          </div>
          <div className="faq-list">
            {faqData.map((faq, index) => (
              <div key={index} className={`faq-item ${openFaqIndex === index ? 'open' : ''}`}>
                <div className="faq-question-row" onClick={() => setOpenFaqIndex(openFaqIndex === index ? -1 : index)}>
                  <div className="faq-question">{faq.question}</div>
                  <span className="faq-chevron">
                    {openFaqIndex === index ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 14L12 10L16 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 10L12 14L8 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </span>
                </div>
                <div className="faq-divider"></div>
                <div className="faq-answer">{faq.answer}</div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
}

export default FAQ;
